import Vue from 'vue/dist/vue.esm';
import VueRouter from 'vue-router';
import Index from './pages/index.vue';
import Admin from './pages/admin/index.vue';
import Taxonomy from './pages/taxonomy/index.vue';
import Inquiry from './pages/inquiry.vue';
Vue.use(VueRouter);

const routes = [
  { path: '/design-base', name: 'root', component: Index },
  // { path: '/design-base/admin', name: 'admin', component: Admin },
  { path: '/design-base/category/:id', name: 'category', component: Taxonomy },
  { path: '/design-base/inquiry', name: 'inquiry', component: Inquiry }
];

export default new VueRouter({ mode: 'history', routes });